import { useMutation } from "@tanstack/react-query";
import { useCallback } from "react";
import { useAuth0 } from "@auth0/auth0-react";

import { PostExportCases } from "../../api/api";

type ExportCasesResult = {
  status: string;
  msg: string;
};

type ExportCasesInput = {
  AccountId: string;
  pagination: {
    limit: string;
    skip: string;
  };
  filters: Array<{
    caseId: string[];
  }>;
};

export const useExportCases = () => {
  const { getAccessTokenSilently } = useAuth0();

  const mutation = useMutation({
    mutationFn: ({
      AccountId,
      pagination,
      filters,
      token,
    }: ExportCasesInput & {
      token: string;
    }): Promise<ExportCasesResult> =>
      PostExportCases(token, {
        AccountId,
        pagination,
        filters,
      }),

    onSuccess: (data) => {
      console.log("Case export result:", data);
    },

    onError: (error) => {
      console.error(
        "Error performing case export:",
        error
      );
    },
  });

  const mutateWithToken = useCallback(
    async (
      { AccountId, pagination, filters }: ExportCasesInput,
      options?: {
        onSuccess?: (data: ExportCasesResult) => void;
        onError?: (error: any) => void;
        onSettled?: () => void;
      }
    ) => {
      const token = await getAccessTokenSilently();
      mutation.mutate(
        {
          AccountId,
          pagination,
          filters,
          token,
        },
        {
          onSuccess: options?.onSuccess,
          onError: options?.onError,
          onSettled: options?.onSettled,
        }
      );
    },
    [getAccessTokenSilently, mutation]
  );

  return { ...mutation, mutate: mutateWithToken };
};
